import { render } from "./NumberControl.vue?vue&type=template&id=563c3aae&scoped=true"
import script from "./NumberControl.vue?vue&type=script&lang=js"
export * from "./NumberControl.vue?vue&type=script&lang=js"

import "./NumberControl.vue?vue&type=style&index=0&id=563c3aae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563c3aae"]])

export default __exports__